import { gql } from '@apollo/client';
import { Organization } from '../types/organizations';

export type GetOrganization = {
  getOrganization: Organization | null;
}

export type GetOrganizationVariables = {
  id: string;
}

const GET_ORGANIZATION = gql`
query getOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    name
    display_name
    branding {
      logo_url
    }
  }
}
`;

export default GET_ORGANIZATION;
